export const icons = {
  items: [
    { icon: "accountBox", name: "Usuário" },
    { icon: "arrowBack", name: "Seta Voltar" },
    { icon: "arrowForward", name: "Seta Frente" },
    { icon: "arrowNorth", name: "Seta Norte" },
    { icon: "arrowSouth", name: "Seta Sul" },
    { icon: "autorenew", name: "Atualizar" },
    { icon: "article", name: "Artigo" },
    { icon: "bank", name: "Banco" },
    { icon: "book", name: "Livro" },
    { icon: "brightnessHight", name: "Brilho" },
    { icon: "build", name: "Ferramenta" },
    { icon: "cancel", name: "Cancelar" },
    { icon: "chevronLeft", name: "Divisa Esquerda" },
    { icon: "chevronRight", name: "Divisa Direira" },
    { icon: "chevronUp", name: "Divisa Cima" },
    { icon: "currencyExchange", name: "Moeda" },
    { icon: "contactSupport", name: "Suporte ao Cliente" },
    { icon: "cube", name: "Cubo" },
    { icon: "chat", name: "Chat" },
    { icon: "construction", name: "Construção" },
    { icon: "dashboard", name: "Painel" },
    { icon: "description", name: "Descrição" },
    { icon: "desktop", name: "Desktop" },
    { icon: "devices", name: "Dispositivos" },
    { icon: "database", name: "Banco de Dados" },
    { icon: "download", name: "Baixar" },
    { icon: "downloadForOffline", name: "Baixar para Offline" },
    { icon: "drafts", name: "Rascunhos" },
    { icon: "donutSmall", name: "Rosquinha Pequena" },
    { icon: "editSquare", name: "Editar Quadrado" },
    { icon: "emergency", name: "Emergência" },
    { icon: "emergencyHome", name: "Emergência em Casa" },
    { icon: "error", name: "Erro" },
    { icon: "event", name: "Evento" },
    { icon: "eventAvailable", name: "Evento Disponível" },
    { icon: "eventBusy", name: "Evento Ocupado" },
    { icon: "filter", name: "Filtro" },
    { icon: "factCheck", name: "Verificação de Fatos" },
    { icon: "feed", name: "Feed" },
    { icon: "group", name: "Grupo" },
    { icon: "groups", name: "Grupos" },
    { icon: "home", name: "Casa" },
    { icon: "help", name: "Ajuda" },
    { icon: "helpCenter", name: "Centro de Ajuda" },
    { icon: "healthAndSafety", name: "Saúde e Segurança" },
    { icon: "heapSnapshotLarge", name: "Heap Snapshot Grande" },
    { icon: "image", name: "Imagem" },
    { icon: "importContacts", name: "Importar Contatos" },
    { icon: "info", name: "Informação" },
    { icon: "iventory", name: "Inventário" },
    { icon: "key", name: "Chave" },
    { icon: "label", name: "Etiqueta" },
    { icon: "laptop", name: "Laptop" },
    { icon: "laptopChart", name: "Gráfico no Laptop" },
    { icon: "laptopMoney", name: "Dinheiro no Laptop" },
    { icon: "laptopPlus", name: "Laptop Mais" },
    { icon: "launch", name: "Lançar" },
    { icon: "leaderboard", name: "Placar" },
    { icon: "lightbulb", name: "Lâmpada" },
    { icon: "listAlt", name: "Lista Alternativa" },
    { icon: "lock", name: "Trancar" },
    { icon: "lockOpen", name: "Destrancar" },
    { icon: "money", name: "Dinheiro" },
    { icon: "mail", name: "Correio" },
    { icon: "notifications", name: "Notificações" },
    { icon: "orderApprove", name: "Aprovação de Pedido" },
    { icon: "pdf", name: "PDF" },
    { icon: "person", name: "Pessoa" },
    { icon: "personAdd", name: "Adicionar Pessoa" },
    { icon: "personRemove", name: "Remover Pessoa" },
    { icon: "pix", name: "Pix" },
    { icon: "place", name: "Lugar" },
    { icon: "questionAnswer", name: "Pergunta e Resposta" },
    { icon: "school", name: "Escola" },
    { icon: "settings", name: "Configurações" },
    { icon: "security", name: "Segurança" },
    { icon: "today", name: "Hoje" },
    { icon: "trashDelete", name: "Excluir" },
    { icon: "topic", name: "Tópico" },
    { icon: "verified", name: "Verificado" },
    { icon: "verifiedUser", name: "Usuário Verificado" },
    { icon: "visibility", name: "Visibilidade" },
    { icon: "visibilityOff", name: "Visibilidade Desativada" },
    { icon: "warning", name: "Aviso" },
    { icon: "watchLater", name: "Assistir Depois" },
    { icon: "phoneInTalk", name: "Telefone" },
    { icon: "queryStats", name: "Estatísticas de Consulta" },
    { icon: "rocketLaunch", name: "Foguete" },
    { icon: "swipeRight", name: "Deslizar para Direita" },
    { icon: "thumbUp", name: "Polegar para Cima" },
    { icon: "handMoney", name: "Mão Dinheiro" },
    { icon: "smartphone", name: "Celular" },
    { icon: "corporate", name: "Corporativa" },
  ],
};
